























































































































































































































































































































































































































































































































import {Component, Watch} from 'vue-property-decorator'
import UserQuestionList from '../organisms/UserQuestionList.vue'
import UserQuestionDialog from '../organisms/UserQuestionDialog.vue'
import ReviewDialog from '../organisms/ReviewDialog.vue'
import ReviewEditDialog from '../organisms/ReviewEditDialog.vue'
import markdownParser from '../../../../helpers/markdown-parser'
import CommentContainer from '../organisms/CommentContainer.vue'
import IframeLoading from '../atoms_molecules/IframeLoading.vue'
import MesageContainer from '../organisms/MesageContainer.vue'
import ThreadContainer from '../organisms/ThreadContainer.vue'
import {mixins} from 'vue-class-component'
import CourseMyDetailMixin from './CourseMyDetailMixin'
import TeacherView from '../atoms_molecules/TeacherView.vue'
import UserQuestion from '../../../api/v2/models/user_question'
import UserQuestionDetailModal from '../organisms/UserQuestionDetailModal.vue'
import {Multipane, MultipaneResizer} from 'vue-multipane'
import LiveChat from "../organisms/LiveChat.vue";

@Component({
  components: {
    LiveChat,
    UserQuestionList,
    UserQuestionDialog,
    ReviewDialog,
    ReviewEditDialog,
    CommentContainer,
    IframeLoading,
    TeacherView,
    MesageContainer,
    ThreadContainer,
    UserQuestionDetailModal,
    Multipane,
    MultipaneResizer,
  }
})
export default class CourseMyDetailMobile extends mixins(CourseMyDetailMixin) {
  currentQuestion: UserQuestion | null = null;
  questionMode: 'list' | 'show' | 'new' = 'list'
  newQuestionCreatedFlag = false
  resizeOb: ResizeObserver = null
  showCreateThreadBtn = true

  updated() {
    this.$nextTick(() => {
      setTimeout(() => {
        // handle resize chat
        if (this.resizeOb === undefined) return
        const lessonSidebar = this.$refs.lessonSidebar as HTMLElement
        const lessonSidebarContainer = this.$refs.lessonSidebarContainer as HTMLElement

        if (!lessonSidebar || !lessonSidebarContainer) return

        this.resizeOb = new ResizeObserver((entries) => {
          let rect = entries[0].contentRect;
          let width = rect.width;
          lessonSidebar.style.width = width + "px"
        })

        try {
          this.resizeOb.observe(lessonSidebarContainer)
        } catch (error) {
          console.warn('Failed to observe lessonSidebarContainer:', error)
        }
      }, 500)
    })
  }

  beforeUnmount() {
    const lessonSidebarContainer = this.$refs.lessonSidebarContainer as HTMLElement
    if (this.resizeOb && lessonSidebarContainer) {
      this.resizeOb.unobserve(lessonSidebarContainer)
    }
  }

  updateParentTab(value: number) {
    this.tab = value
  }

  onClickQuestion(question: UserQuestion) {
    this.currentQuestion = question
    this.questionMode = 'show'
    this.newQuestionCreatedFlag = false
  }

  onBackQuestionList() {
    this.currentQuestion = null
    this.questionMode = 'list'
    this.newQuestionCreatedFlag = false
  }

  @Watch("tab")
  changeTabValue() {
    this.$nextTick(() => {
      if (!this.currentLesson) return
      const params = new URLSearchParams(window.location.search)
      if (!this.tab || isNaN(this.tab)) {
        this.tab = this.currentLesson.lesson.lessonType == 'live' ? 0 : 1
      }

      params.set('tab', this.tab.toString())
      window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`))
    })
  }

  emitCreateThread(value: number) {
    if (typeof value === 'number') {
      this.tab = value;
    }
    (this.$refs.mesageContainer as any).createThread()
    this.showCreateThreadBtn = false
  }

  toggleCreateThreadBtn(value: boolean) {
    this.showCreateThreadBtn = value
  }

  scrollLiveChatToBottom() {
    setTimeout(() => {
      const messageContainer = this.$refs.liveChatContainer as any
      messageContainer.scrollToLast()
    }, 250)
  }

  scrollChatToBottom() {
    setTimeout(() => {
      const messageContainer = this.$refs.mesageContainer as any
      messageContainer.scrollToLast()
    }, 250)
  }
}
